import { create } from 'zustand'

interface BreadcrumbStore {
  dynamicLabels: Record<string, string>
  setDynamicLabel: (paramKey: string, label: string) => void
  clearDynamicLabel: (paramKey: string) => void
}

const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  dynamicLabels: {},
  setDynamicLabel: (paramKey, label) =>
    set((state) => ({ dynamicLabels: { ...state.dynamicLabels, [paramKey]: label } })),
  clearDynamicLabel: (paramKey) =>
    set((state) => {
      const { [paramKey]: _, ...rest } = state.dynamicLabels
      return { dynamicLabels: rest }
    }),
}))

export default useBreadcrumbStore
